<template>
  <div class="table-freeze-wrapper">
    <table class="table-freeze">
      <thead>
        <tr class="thead-level-1">
          <th rowspan="2" class="sticky-col col-no text-center">
            No
          </th>

          <th rowspan="2" class="sticky-col col-kode">
            Kode Proyek
          </th>

          <th rowspan="2" class="sticky-col col-nama">
            Nama Proyek
          </th>

          <th rowspan="2" class="text-right">
            Nilai Proyek
          </th>

          <th rowspan="2" class="text-right">
            Beban Proyek
          </th>

          <th colspan="2" class="text-center group-header">
            Penagihan Project
          </th>

          <th colspan="2" class="text-center group-header">
            Pembayaran Project
          </th>

          <th colspan="2" class="text-center group-header">
            Delivery Beban Project
          </th>

          <th rowspan="2" class="sticky-col-right col-aksi text-center">
            Aksi
          </th>
        </tr>

        <tr class="thead-level-2">
          <th class="text-right sub-header">
            Sudah Ditagih
          </th>

          <th class="text-right sub-header">
            Belum Ditagih
          </th>

          <th class="text-right sub-header">
            Sudah Dibayar
          </th>

          <th class="text-right sub-header">
            Belum Dibayar
          </th>

          <th class="text-right sub-header">
            Sudah Dibayar
          </th>

          <th class="text-right sub-header">
            Belum Dibayar
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
          :class="{ 'row-hover': hoveredIndex === index }"
          @mouseover="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <td class="sticky-col col-no text-center">
            {{ item.no }}
          </td>

          <td class="sticky-col col-kode font-weight-medium">
            <a
              href="javascript:void(0)"
              class="text-primary text-underline"
              title="Klik untuk melihat rincian lengkap proyek"
              @click="$emit('click-detail', item)"
            >
              {{ item.kode_proyek }}
            </a>
          </td>

          <td
            class="sticky-col col-nama text-truncate-custom"
            :title="item.nama_proyek"
          >
            {{ item.nama_proyek }}
          </td>

          <td class="text-right text-success font-weight-bold">
            {{ formatRupiah(item.nilai_proyek) }}
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-dark text-underline"
              title="Klik untuk melihat rincian SPH"
              @click="$emit('click-sph', item)"
            >
              {{ formatRupiah(item.beban_proyek) }}
            </a>
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-info text-underline"
              title="Klik untuk melihat rincian tagihan"
              @click="$emit('click-tagihan', item, 'sudah_ditagih')"
            >
              {{ formatRupiah(item.sudah_ditagih_ke_pemberi_kerja) }}
            </a>
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-warning text-underline"
              title="Klik untuk melihat rincian belum ditagih"
              @click="$emit('click-tagihan', item, 'belum_ditagih')"
            >
              {{ formatRupiah(item.belum_ditagih_ke_pemberi_kerja) }}
            </a>
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-primary text-underline"
              title="Klik untuk melihat rincian pembayaran pelanggan"
              @click="$emit('click-tagihan', item, 'sudah_dibayar')"
            >
              {{ formatRupiah(item.sudah_dibayar_pemberi_kerja) }}
            </a>
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-danger text-underline"
              title="Klik untuk melihat rincian belum dibayar"
              @click="$emit('click-tagihan', item, 'belum_dibayar')"
            >
              {{ formatRupiah(item.belum_dibayar_pemberi_kerja) }}
            </a>
          </td>

          <td class="text-right">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-danger text-underline"
              title="Klik untuk melihat rincian pembayaran ke mitra"
              @click="$emit('click-panjar', item, 'SUDAH_BAYAR')"
            >
              {{ formatRupiah(item.sudah_dibayar_ke_mitra) }}
            </a>
          </td>

          <td class="text-right font-weight-medium">
            <a
              href="javascript:void(0)"
              class="font-weight-bold text-warning text-underline"
              title="Klik untuk melihat rincian panjar yang belum dibayar"
              @click="$emit('click-panjar', item, 'BELUM_BAYAR')"
            >
              {{ formatRupiah(item.belum_dibayar_ke_mitra) }}
            </a>
          </td>

          <td class="sticky-col-right col-aksi text-center">
            <div
              class="d-flex justify-content-center align-items-center style-gap"
            >
              <b-button
                variant="outline-primary"
                size="sm"
                class="p-1 d-flex align-items-center justify-content-center"
                title="Lihat Detail Ringkasan Finansial"
                @click="$emit('click-detail', item)"
              >
                <feather
                  type="eye"
                  size="16"
                  style="cursor: pointer;"
                ></feather>
              </b-button>

              <b-button
                variant="outline-success"
                size="sm"
                class="p-1 d-flex align-items-center justify-content-center"
                title="Download Data Proyek"
                @click="$emit('click-download', item)"
              >
                <feather
                  type="download"
                  size="16"
                  style="cursor: pointer;"
                ></feather>
              </b-button>
            </div>
          </td>
        </tr>

        <tr v-if="items.length === 0">
          <td colspan="12" class="text-center text-muted py-4">
            Tidak ada data proyek yang ditemukan.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProjectTable',

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    formatRupiah: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      hoveredIndex: null,
    }
  },
}
</script>

<style scoped>
.table-freeze-wrapper {
  overflow: auto;
  width: 100%;
  max-height: 75vh;
  border: 1px solid #dee2e6;
}

.table-freeze {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1800px;
  font-size: 13px;
}

/* =========================================================
   CELL BASE & BORDER FIX FOR STICKY
========================================================= */
.table-freeze th,
.table-freeze td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
}

/* Berikan border atas dan kiri hanya pada elemen paling ujung agar tidak double */
.table-freeze th {
  border-top: 1px solid #dee2e6;
}
.table-freeze th:first-child,
.table-freeze td:first-child {
  border-left: 1px solid #dee2e6;
}

/* =========================================================
   STICKY HEADER (Scroll Vertikal)
========================================================= */
.table-freeze thead th {
  position: sticky;
  background-color: #ffffff;
}

/* Level 1 menempel di paling atas */
.thead-level-1 th {
  top: 0;
  z-index: 20;
}

/* Level 2 menempel tepat di bawah level 1 (37px adalah tinggi presisi level 1 dengan padding 8px) */
.thead-level-2 th {
  top: 37px;
  z-index: 19;
}

/* =========================================================
   HEADER STYLE & COLOR FIX (Sticky-Safe)
========================================================= */
.table-freeze thead .group-header {
  background: #e9ecef !important;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
}

.table-freeze thead .sub-header {
  background: #f8f9fa !important;
  font-size: 12px;
  font-weight: 600;
}

/* =========================================================
   STICKY COLUMN (Scroll Horizontal Kiri)
========================================================= */
.sticky-col {
  position: sticky;
  background: #fff;
  z-index: 10;
}

/* Menaikkan tingkat Z-Index TH agar menutupi sub-header saat scroll horizontal */
.thead-level-1 th.sticky-col {
  top: 0;
  z-index: 50;
}

.thead-level-2 th.sticky-col {
  top: 37px;
  z-index: 45;
}

.col-no {
  left: 0;
  width: 60px;
  min-width: 60px;
}

.col-kode {
  left: 60px;
  width: 170px;
  min-width: 170px;
}

.col-nama {
  left: 230px;
  width: 300px;
  min-width: 300px;
}

/* =========================================================
   STICKY COLUMN RIGHT (Scroll Horizontal Kanan)
========================================================= */
.sticky-col-right {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 10;
  box-shadow: -4px 0 6px -2px rgba(0, 0, 0, 0.08);
}

.thead-level-1 th.sticky-col-right {
  top: 0;
  z-index: 50;
}

.thead-level-2 th.sticky-col-right {
  top: 37px;
  z-index: 45;
}

.col-aksi {
  width: 95px;
  min-width: 95px;
}

.style-gap {
  gap: 6px;
}

/* =========================================================
   TEXT
========================================================= */
.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.font-weight-bold {
  font-weight: 700;
}

.font-weight-medium {
  font-weight: 600;
}

.text-success {
  color: #198754;
}

.text-danger {
  color: #dc3545;
}

.text-warning {
  color: #fd7e14;
}

.text-info {
  color: #0dcaf0;
}

.text-primary {
  color: #0d6efd;
}

.text-dark {
  color: #212529;
}

.text-muted {
  color: #6c757d;
}

/* =========================================================
   LINK
========================================================= */
.text-underline {
  text-decoration: underline;
  cursor: pointer;
}

/* =========================================================
   ROW HOVER
========================================================= */
.row-hover td {
  background-color: #f8f9fa !important;
}

tr.row-hover .sticky-col,
tr.row-hover .sticky-col-right {
  background-color: #f8f9fa !important;
}

/* =========================================================
   TEXT TRUNCATE
========================================================= */
.text-truncate-custom {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =========================================================
   SHADOW STICKY
========================================================= */
.col-nama {
  box-shadow: 4px 0 6px -2px rgba(0, 0, 0, 0.08);
}

/* =========================================================
   SCROLLBAR
========================================================= */
.table-freeze-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

.table-freeze-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.table-freeze-wrapper::-webkit-scrollbar-track {
  background: #f8fafc;
}
</style>
